export default __webpack_public_path__ + "static/media/icon-plus-green-outline.59fef23c.svg";